import { types } from './actions';

const initialState = {
  isOpen: false,
  realTimePricingPlan: null,
  componentId: null,
};

// eslint-disable-next-line default-param-last
const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.REAL_TIME_PRICING_DRAWER_OPEN:
      return {
        ...state,
        isOpen: true,
        realTimePricingPlan: payload.realTimePricingPlan,
        componentId: payload.componentId,
      };
    case types.REAL_TIME_PRICING_DRAWER_CLOSE:
      return {
        ...state,
        isOpen: false,
        realTimePricingPlan: null,
        componentId: null,
      };
    default:
      return state;
  }
};

const getScope = (state) =>
  state.modules.quotes.quoteItemComponents.realTimePricingDrawer;

export const getIsOpen = (state) => getScope(state).isOpen;

export const getRealTimePricingPlan = (state) =>
  getScope(state).realTimePricingPlan;

export const getComponentId = (state) => getScope(state).componentId;

export default reducer;
